import Invoice, { ErrorInvoice } from 'requests/objects/invoice'
// eslint-disable-next-line import/no-cycle, import/named
import ApiHandler from 'requests/apiHandler'

/**
 * InvoicesHandler
 *
 * Created on 2026-02-02.
 * Updated on 2026-06-29.
 *
 * @author Hassen MALEK
 * @version 1.1.0
 * @augments {ApiHandler<Invoice, ErrorInvoice>}
 */
export default class InvoicesHandler extends ApiHandler {
    constructor() {
        super({ type: Invoice, errorType: ErrorInvoice, key: 'invoices' })
    }

    getAllFromPage(params = {}, currentPage = 1, recordsPerPage = 20) {
        const request = this.initFetchRequest({
            params: {
                ...params,
                currentPage,
                recordsPerPage,
            },
        })

        return this.getRequestApi(
            () => request.fetchRequest
                .then(res => res.data)
                .then(({ invoices, totalRecords, totalPages }) => {
                    const items = (invoices ?? []).map(o => new Invoice(o))
                    return { items, totalRecords, totalPages }
                })
                .catch(err => { throw this.handleError(err) }),
            request.cancelToken,
        )
    }
}
